export const enum Keys {
    DOWN = 40,
    ENTER = 13,
    ESCAPE = 27,
    LEFT = 37,
    PAGE_DOWN = 34,
    PAGE_UP = 33,
    RIGHT = 39,
    UP = 38,
    BACKSPACE = 8,
    DELETE = 46,
    KEY_A = 65,
    KEY_B = 66,
    KEY_C = 67,
    KEY_G = 71,
    KEY_I = 73,
    KEY_L = 76,
    KEY_O = 79,
    KEY_P = 80,
    KEY_R = 82,
    KEY_S = 83,
    KEY_T = 84,
    KEY_U = 85,
    KEY_V = 86,
    KEY_X = 88,
    KEY_Y = 89,
    KEY_Z = 90,
    SHIFT = 16,
    SPACE_BAR = 32,
}
